import React from 'react'
import { StackedImage } from './StackedImage'

/**
 * CardPlaceholder component
 *
 * This component renders a non-draggable placeholder for cards that are currently
 * placed in slots. It's necessary to avoid duplicate draggable elements with the
 * same ID, which would cause conflicts in dnd-kit.
 *
 * The issue: If we render the same card as a DraggableCard in both the bottom list
 * and in a slot, dnd-kit gets confused because there are two draggable elements
 * with identical IDs. This causes dragging to stop working after the first drop.
 *
 * The solution: When a card is placed in a slot, we show this placeholder in the
 * bottom list instead. The placeholder looks identical to the original card but
 * is faded out and non-interactive, indicating that the card is in use elsewhere.
 * Only the card in the slot remains draggable, preventing ID conflicts.
 */
export const CardPlaceholder = ({ card, style, gameType }) => {
  return (
    <div
      style={{
        ...style,
        opacity: 0.2,
        cursor: 'not-allowed',
        touchAction: 'none',
      }}
    >
      <StackedImage
        style={{
          pointerEvents: 'none',
        }}
        className="draggable-card bottom-list"
        image={card}
        gameType={gameType}
      />
    </div>
  )
}
